import React from "react";
import ReactDOM from "react-dom/client";
import { AppRouter } from "./routes";
import { applyTheme } from "./lib/theme";
import "./index.css";

// Resolve theme synchronously BEFORE the first React render. Without this,
// <html> has no `light`/`dark` class until the quiz store's loadAll fires —
// which only happens for authenticated users on protected routes. Unauthed
// pages (/login etc.) used to render with CSS dark-defaults while the
// BrandMark component picked its variant from matchMedia, causing the
// "light wordmark on dark background" mismatch Doron caught on iPhone.
applyTheme("system");

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root missing in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
);

// Register the service worker (PWA). Fire-and-forget on load so a registration
// hiccup doesn't block the app from rendering. Skipped on `npm run dev` (Vite
// serves /sw.js but the dev experience is HMR-driven; we don't want a cached
// SW interfering with hot reloads).
if (
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  import.meta.env.PROD
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* user-facing app keeps working without offline support */
    });
  });
}
